export enum TaxItemTypeEnum {
  PERCENT = 'PERCENT',
  PER_PAX = 'PER_PAX'
}
